/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Or_Manual_ControlInputs */



/**
* | output |
* | --- |
* | "Automatic or manual control" |
*
* @param {Auto_Or_Manual_ControlInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auto_or_manual_control = /** @type {((inputs?: Auto_Or_Manual_ControlInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Or_Manual_ControlInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Automatic or manual control")
	return /** @type {LocalizedString} */ ("Contrôle automatique ou manuel")
});